import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '@core/services/environment/environment.service';
import { AuthStore } from '@features/authentication/state/auth.store';

function normalizeBase(url: string): string {
  if (!url) return '';
  return url.endsWith('/') ? url : url + '/';
}

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(EnvironmentService);
  const authStore = inject(AuthStore);

  const apiBase = normalizeBase(env.getApiUrl());
  const url = req.url;

  // Solo intercepta si la request va a tu API (evita adjuntar a CDNs, assets, etc.)
  const isAbsolute = /^https?:\/\//i.test(url);
  const target = isAbsolute ? url : apiBase + url; // soporta rutas relativas si las usas
  const isApiCall = target.startsWith(apiBase);

  if (!isApiCall) {
    return next(req);
  }

  const token = authStore.effectiveToken();
  const headers: Record<string, string> = {};

  if (token && !req.headers.has('Authorization')) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Estandarizar contexto de área pública para robustecer validación en backend
  if (!req.headers.has('x-client-app')) {
    headers['x-client-app'] = 'public-area';
  }

  if (Object.keys(headers).length > 0) {
    const authReq = req.clone({ setHeaders: headers });
    return next(authReq);
  }

  return next(req);
};
